// import { isMainDomain } from '../utils/common.js';
import ChangePassword from '../components/Authentication/changePassword';
import ForgotPassword from '../components/Authentication/ForgotPassword';
import Login, { FindTenantForm } from '../components/Authentication/Login';
import RequestAccess from '../components/Authentication/RequestAccess';
import Dashboard from '../components/Dashboard/Dashboard';
import AdminLayout from '../layout/AdminLayout';
import { isMainDomain } from 'utils/common';
import { TenantCharts } from 'components/Tenant/TenantCharts';
import { UsersList } from 'components/Users/UsersList';
import { TenantConfiguration } from 'components/Tenant/TenantConfiguration';
import { UserPage } from 'components/Users/UserPage';
import { NewUserPage } from 'components/Users/NewUserPage';
import FindTenantPage from 'components/Authentication/FindTenantPage';
import ErrorPage from 'components/Errors/ErrorPage';
import ErrorPage_github_link_error from 'components/Errors/ErrorPage_github_link_error';
import { GithubApiUI } from 'components/Authentication/GithubApiUI';
import DeployPublicProjectPage from 'components/Authentication/DeployPublicProjectPage';
import { PaymentOk } from 'components/Payments/PaymentOk';
import { PaymentError } from 'components/Payments/PaymentError';
import { TariffsPage } from 'components/Payments/TariffsPage';
import CreateUserPassword from '../components/Authentication/CreateUserPassword';
import { NoApplication } from 'components/SharedComponents/NoPage/NoPages';
import { StoryPage } from 'components/Story/StoryPage';
import { UniversePage } from 'components/Universe/UniversePage';
import UniverseList from 'components/Universe/UniverseList';
let adminRoutes = [];

const isAuth_layout = { isAuth: true, layout: AdminLayout };

if (!isMainDomain()) {
  // if window.location.host have only one dot symbol then this main site like nanoheal.site
  // if window.location.host has 2 dot symbols then this organization site like tesla.nanoheal.site
  adminRoutes = [
    {
      ...isAuth_layout,
      path: '/',
      component: Dashboard,
    },
    {
      ...isAuth_layout,
      path: '/story/:storyId',
      component: StoryPage,
    },
    {
      ...isAuth_layout,
      path: '/story/:storyId/:tabName',
      component: StoryPage,
    },
    {
      ...isAuth_layout,
      path: '/universe',
      component: UniverseList,
    },
    {
      ...isAuth_layout,
      path: '/universe/:universeId',
      component: UniversePage,
    },
    {
      ...isAuth_layout,
      path: '/universe/:universeId/:tabName',
      component: UniversePage,
    },
    {
      ...isAuth_layout,
      path: '/first-step',
      component: NoApplication,
    },
    {
      ...isAuth_layout,
      path: '/users',
      component: UsersList,
    },
    {
      ...isAuth_layout,
      path: '/users/new',
      component: NewUserPage,
    },
    {
      ...isAuth_layout,
      path: '/users/:userId',
      component: UserPage,
    },
    {
      ...isAuth_layout,
      path: '/configuration',
      component: TenantConfiguration,
    },
    {
      ...isAuth_layout,
      path: '/charts/:tabName',
      component: TenantCharts,
    },
    {
      ...isAuth_layout,
      path: '/charts',
      component: TenantCharts,
    },
    {
      ...isAuth_layout,
      path: '/github-api-ui/:params/:accessToken',
      component: GithubApiUI,
    },
    {
      ...isAuth_layout,
      path: '/payment/ok',
      component: PaymentOk,
    },
    {
      ...isAuth_layout,
      path: '/payment/error',
      component: PaymentError,
    },
    {
      ...isAuth_layout,
      path: '/tariffs',
      component: TariffsPage,
    },
  ];
} else {
  adminRoutes = [{ path: '/', component: Login }];
}

export let publicRoutes = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/login/r/:oldPath',
    component: Login,
  },
  {
    path: '/signup',
    component: RequestAccess,
  },
  {
    path: '/login/email/:email',
    component: Login,
  },
  {
    path: '/requestaccess',
    component: RequestAccess,
  },
  {
    path: '/find-tenant',
    component: FindTenantPage,
  },
  {
    path: '/deploy/:projectUUID',
    component: DeployPublicProjectPage,
  },
  {
    path: '/reset-password',
    component: ForgotPassword,
  },
  {
    path: '/changePassword',
    component: ChangePassword,
  },
  {
    path: '/error-page/:message',
    component: ErrorPage,
  },
  {
    path: '/github-link-error',
    component: ErrorPage_github_link_error,
  },
  {
    path: '/password-reset',
    component: FindTenantForm,
  },
  {
    path: '/password-create',
    component: CreateUserPassword,
  },
];

if (isMainDomain()) {
  adminRoutes = [];
  publicRoutes = [
    {
      path: '/error-page/:message',
      component: ErrorPage,
    },
    {
      path: '/requestaccess',
      component: RequestAccess,
    },
    {
      path: '/find-tenant',
      component: FindTenantPage,
    },
    {
      path: '/login/email/:email',
      component: Login,
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/signup',
      component: RequestAccess,
    },
    { path: '/', component: Login },
    { path: '', component: Login },
  ];
}

export const routeConfigAdminLayout = [...publicRoutes, ...adminRoutes];
